import { ComponentProps, FC } from 'react'
import { IconWrapper } from '../wrapper'

export const IconEmojiGreatMatch: FC<ComponentProps<typeof IconWrapper>> = (props) => {
  const { size = 20, color = 'currentColor' } = props
  return (
    <IconWrapper {...props} size={size}>
      <svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.16602 11.6666C7.16602 11.6666 8.41602 13.3333 10.4993 13.3333C12.5827 13.3333 13.8327 11.6666 13.8327 11.6666M7.99935 7.49996H8.00768M12.9993 7.49996H13.0077M18.8327 9.99996C18.8327 14.6023 15.1017 18.3333 10.4993 18.3333C5.89698 18.3333 2.16602 14.6023 2.16602 9.99996C2.16602 5.39759 5.89698 1.66663 10.4993 1.66663C15.1017 1.66663 18.8327 5.39759 18.8327 9.99996Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </IconWrapper>
  )
}
